import { middlewareController } from '../middlewareController'

const BASE_URL = process.env.REACT_APP_APPOINTLY_API_ENDPOINT

export const appointlyApi = middlewareController.create.axiosInstance({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export * from './requests'
